/* ============================================================
   CRÉATURES ÉDITIONS — theme.js
   Navigation, hero, catalogue scroll reveal, cart drawer.
   ============================================================ */

(function () {
  'use strict';

  /* ── NAV OVERLAY ── */
  var overlay = document.getElementById('cr-overlay');
  if (overlay) {
    var triggers = document.querySelectorAll('[data-cr-open]');
    var closers  = overlay.querySelectorAll('[data-cr-close]');
    var links    = overlay.querySelectorAll('[data-cr-link]');

    function openNav() {
      overlay.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
        });
      });
      document.body.classList.add('cr-no-scroll');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    }
    function closeNav() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('cr-no-scroll');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { overlay.hidden = true; }, 800);
    }
    triggers.forEach(function (t) { t.addEventListener('click', openNav); });
    closers.forEach(function (c) { c.addEventListener('click', closeNav); });
    links.forEach(function (l) {
      l.addEventListener('click', function () {
        overlay.classList.remove('is-open');
        setTimeout(function () { overlay.hidden = true; }, 800);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeNav();
    });
  }

  /* ── HEADER TRANSPARENT ON HERO ── */
  var header = document.querySelector('.cr-header');
  if (header) {
    var heroSection = document.querySelector('.cr-hero, .cr-b3d, .cr-dr__hero');
    if (heroSection) {
      header.classList.add('cr-header--transparent');
      window.addEventListener('scroll', function () {
        if (window.scrollY > 60) {
          header.classList.remove('cr-header--transparent');
        } else {
          header.classList.add('cr-header--transparent');
        }
      }, { passive: true });
    }
  }

  /* ── HERO SLIDESHOW ── */
  document.querySelectorAll('[data-cr-hero]').forEach(function (root) {
    var slides   = Array.from(root.querySelectorAll('[data-cr-slide]'));
    var dots     = Array.from(root.querySelectorAll('[data-cr-dot]'));
    if (!slides.length) return;

    var i         = 0;
    var timer     = null;
    var autoplay  = root.dataset.autoplay === 'true' && slides.length > 1;
    var interval  = parseInt(root.dataset.interval, 10) || 6000;
    var reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.style.setProperty('--cr-fill', (interval / 1000) + 's');

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d) {
        d.classList.remove('is-active');
        var f = d.querySelector('.cr-hero__dot-fill');
        if (f) { f.style.transition = 'none'; f.style.transform = 'scaleX(0)'; }
      });
      if (dots[i]) {
        void dots[i].offsetWidth;
        var f = dots[i].querySelector('.cr-hero__dot-fill');
        if (f) f.style.transition = '';
        dots[i].classList.add('is-active');
      }
    }
    function next() { go(i + 1); }
    function play() { if (!autoplay || reduced) return; stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.dataset.crDot, 10)); play();
      });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    go(0); play();

    /* 3D mouse parallax */
    if (!reduced && window.matchMedia('(hover: hover)').matches) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(loop3d);
      });
      root.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(loop3d);
      });
      function loop3d() {
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        var act = slides[i];
        if (act) {
          var media   = act.querySelector('.cr-hero__media');
          var content = act.querySelector('.cr-hero__content');
          if (media)   media.style.transform   = 'translate3d(' + (-cx * 26) + 'px,' + (-cy * 22) + 'px,0) scale(1.04)';
          if (content) content.style.transform = 'translate3d(' + (cx * 14) + 'px,' + (cy * 10) + 'px,0)';
        }
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) {
          raf = requestAnimationFrame(loop3d);
        } else { raf = null; }
      }
    }
  });

  /* ── CATALOGUE CARD REVEAL ── */
  function revealCards() {
    var cards = document.querySelectorAll('.cr-card');
    if (!cards.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('is-in'); });
    }
  }
  revealCards();

  /* ── CART DRAWER ── */
  var cartDrawer    = document.getElementById('cr-cart-drawer');
  var cartOverlay   = document.querySelector('.cr-cart-drawer__overlay');
  var cartCount     = document.querySelectorAll('[data-cart-count]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.classList.add('cr-no-scroll');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.classList.remove('cr-no-scroll');
  }

  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-close-cart]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  /* Update cart count via AJAX */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartCount.forEach(function (el) {
          el.textContent = data.item_count;
          el.dataset.count = data.item_count;
        });
      })
      .catch(function () {});
  }

  /* Add to cart AJAX */
  document.querySelectorAll('.cr-product__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          refreshCartDrawer();
          openCart();
          if (btn) { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }
        });
    });
  });

  function refreshCartDrawer() {
    if (!cartDrawer) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = cartDrawer.querySelector('.cr-cart-drawer__body');
        var subtotalEl = cartDrawer.querySelector('.cr-cart-drawer__subtotal-amount');
        if (subtotalEl && cart.total_price !== undefined) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
        if (body) {
          if (!cart.items || !cart.items.length) {
            body.innerHTML = '<p class="cr-cart-drawer__empty">Votre panier est vide.</p>';
            return;
          }
          body.innerHTML = cart.items.map(function (item) {
            return '<div class="cr-cart-drawer__item">' +
              (item.featured_image && item.featured_image.url
                ? '<img class="cr-cart-drawer__item-img" src="' + item.featured_image.url + '" alt="' + item.title + '" loading="lazy">'
                : '<div class="cr-cart-drawer__item-img"></div>') +
              '<div class="cr-cart-drawer__item-info">' +
                '<div class="cr-cart-drawer__item-title">' + item.product_title + '</div>' +
                (item.variant_title && item.variant_title !== 'Default Title'
                  ? '<div style="font-family:var(--cr-mono);font-size:11px;color:var(--cr-grey)">' + item.variant_title + '</div>' : '') +
                '<div class="cr-cart-drawer__item-price">x' + item.quantity + ' — ' + formatMoney(item.line_price) + '</div>' +
                '<button class="cr-cart-drawer__item-remove" data-remove-key="' + item.key + '">Retirer</button>' +
              '</div>' +
            '</div>';
          }).join('');
          body.querySelectorAll('[data-remove-key]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              removeItem(btn.dataset.removeKey);
            });
          });
        }
      })
      .catch(function () {});
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function () { refreshCartCount(); refreshCartDrawer(); })
    .catch(function () {});
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ── PRODUCT PAGE : variant selector & gallery ── */
  var productForm = document.querySelector('.cr-product__form');
  if (productForm) {
    var variantBtns = productForm.querySelectorAll('.cr-product__variant-btn');
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.cr-product__variant-options');
        if (group) {
          group.querySelectorAll('.cr-product__variant-btn').forEach(function (b) {
            b.classList.remove('is-selected');
          });
        }
        btn.classList.add('is-selected');
      });
    });
  }

  /* Product gallery thumbnails */
  var thumbs = document.querySelectorAll('.cr-product__thumb');
  var mainImg = document.querySelector('.cr-product__main-img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) {
        var full = thumb.getAttribute('data-full');
        var imgEl = thumb.querySelector('img');
        mainImg.src = full || (imgEl ? imgEl.src : mainImg.src);
        mainImg.removeAttribute('srcset');
      }
    });
  });

  /* ── COMING SOON WebGL background ── */
  var soonCanvas = document.querySelector('.cr-soon__gl');
  if (soonCanvas) {
    var reduced2 = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gl2 = null;
    try { gl2 = soonCanvas.getContext('webgl') || soonCanvas.getContext('experimental-webgl'); } catch (e) {}
    if (gl2 && !reduced2) {
      var vs2 = 'attribute vec2 p; void main(){ gl_Position = vec4(p,0.0,1.0); }';
      var fs2 = [
        'precision highp float;',
        'uniform vec2 r; uniform float t;',
        'float h(vec2 x){ return fract(sin(dot(x,vec2(127.1,311.7)))*43758.5453); }',
        'float n(vec2 x){ vec2 i=floor(x),f=fract(x); float a=h(i),b=h(i+vec2(1.,0.)),c=h(i+vec2(0.,1.)),d=h(i+vec2(1.,1.));',
        '  vec2 u=f*f*(3.-2.*f); return mix(a,b,u.x)+(c-a)*u.y*(1.-u.x)+(d-b)*u.x*u.y; }',
        'float fbm(vec2 x){ float v=0.,a=.5; for(int i=0;i<5;i++){ v+=a*n(x); x*=2.02; a*=.5; } return v; }',
        'void main(){',
        '  vec2 uv=gl_FragCoord.xy/r.xy; vec2 q=uv; q.x*=r.x/r.y;',
        '  float f=fbm(q*3.0+vec2(t*0.05,t*0.03));',
        '  f=fbm(q*3.0+f*1.5+vec2(0.0,t*0.06));',
        '  vec3 base=vec3(0.04,0.04,0.04); vec3 green=vec3(0.30,1.0,0.0);',
        '  float glow=smoothstep(0.55,0.95,f)*(0.45+0.25*sin(t*0.4));',
        '  float top=pow(1.0-uv.y,1.5);',
        '  vec3 col=base+green*glow*0.5*top;',
        '  float vig=smoothstep(1.2,0.2,length(uv-0.5));',
        '  col*=mix(0.7,1.0,vig);',
        '  gl_FragColor=vec4(col,1.0); }'
      ].join('\n');
      function mkShader(type, src) { var s = gl2.createShader(type); gl2.shaderSource(s, src); gl2.compileShader(s); return s; }
      var prog2 = gl2.createProgram();
      gl2.attachShader(prog2, mkShader(gl2.VERTEX_SHADER, vs2));
      gl2.attachShader(prog2, mkShader(gl2.FRAGMENT_SHADER, fs2));
      gl2.linkProgram(prog2); gl2.useProgram(prog2);
      var buf2 = gl2.createBuffer(); gl2.bindBuffer(gl2.ARRAY_BUFFER, buf2);
      gl2.bufferData(gl2.ARRAY_BUFFER, new Float32Array([-1,-1,3,-1,-1,3]), gl2.STATIC_DRAW);
      var loc2 = gl2.getAttribLocation(prog2, 'p');
      gl2.enableVertexAttribArray(loc2); gl2.vertexAttribPointer(loc2, 2, gl2.FLOAT, false, 0, 0);
      var uR2 = gl2.getUniformLocation(prog2, 'r'), uT2 = gl2.getUniformLocation(prog2, 't');
      function soonSize() {
        var dpr = Math.min(window.devicePixelRatio, 1.5);
        soonCanvas.width  = soonCanvas.clientWidth * dpr;
        soonCanvas.height = soonCanvas.clientHeight * dpr;
        gl2.viewport(0, 0, soonCanvas.width, soonCanvas.height);
      }
      soonSize();
      window.addEventListener('resize', soonSize);
      var start2 = performance.now(), raf2;
      function drawSoon() {
        gl2.uniform2f(uR2, soonCanvas.width, soonCanvas.height);
        gl2.uniform1f(uT2, (performance.now() - start2) * 0.001);
        gl2.drawArrays(gl2.TRIANGLES, 0, 3);
        raf2 = requestAnimationFrame(drawSoon);
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!raf2) drawSoon(); }
          else if (raf2) { cancelAnimationFrame(raf2); raf2 = null; }
        });
      }).observe(soonCanvas);
    } else {
      soonCanvas.style.display = 'none';
    }
  }

})();
